export default __webpack_public_path__ + "static/media/insurance cloud-mob.a8b9c852.png";